export const CLIENT_NODE_SWITCH_FEATURE_FLAG = 'seccl-31352-enable-node-switch-ui';
